import { useAsyncExecutor2 } from "async-executor-hook";
import { format } from "date-fns";
import { useState } from "react";
import { filter, from, tap, zip } from "rxjs";

import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";

export const BatchPrefactura = () => {
  const [statistics, setStatistics] = useState({
    completed: 0,
    success: 0,
    failed: 0,
    total: 0,
  });

  const [data, setData] = useState({ volantes: "", dni: "" });

  const [status, setStatus] = useState<any>({ data: null, status: "" });

  const createPrefactura = useAsyncExecutor2(
    (body: any) => {
      const { dam_num1, volante_num } = body;
      const damRequest = networkBackendRequest(
        `/dams/${dam_num1}/estimate/`,
        HTTP_METHODS.GET,
        {
          volante_nums: Array.isArray(volante_num)
            ? volante_num
            : [volante_num],
        }
      );

      const request = from(damRequest)
        .toPromise()
        .then(() => {
          return networkBackendRequest(
            `/quotations/`,
            HTTP_METHODS.POST,
            {},
            { ...body, dam_num1: undefined }
          );
        });
      return from(request);
    },
    {
      retry: {
        interval: 500,
        maxRetryAttempts: 1,
      },
      concurrent: {
        type: "MERGE",
        mergeCapacity: 5,
      },
    }
  );

  return (
    <div className="p-grid" id="createData" style={{ display: "none" }}>
      <div className="p-md-2">
        <br />
        <input
          value={data.dni}
          onChange={(e) => {
            setData({ ...data, dni: e.target.value });
          }}
        />
      </div>

      <div className="p-md-2">
        <br />
        <input
          value={data.volantes}
          onChange={(e) => {
            setData({ ...data, volantes: e.target.value });
          }}
        />
      </div>

      <div className="p-md-2">
        <br />
        <button
          onClick={() => {
            if (status.status === "PROCESSING") return;
            let volantes = [];
            try {
              volantes = JSON.parse(data.volantes);
              if (!Array.isArray(volantes)) {
                alert("Volantes no es un array");
                const error = {};
                throw error;
              }
            } catch (error) {
              alert("No se puede parsear volantes");
              // eslint-disable-next-line no-console
              console.log(error);
              throw error;
            }

            setStatistics((stats) => ({ ...stats, total: volantes.length }));

            setStatus({ status: "PROCESSING" });

            const bodies = volantes.map((combo) => {
              const parteone = combo.dam.slice(0, 6);
              const partetwo = combo.dam.slice(6, 8);
              const partethre = combo.dam.slice(8, 9);
              const parteFour = combo.dam.slice(9, 11);
              return {
                volante_num: combo.volante_num,
                dam_num1: `235-${combo.dam_anio}-10-${parteone}-${partetwo}-${partethre}-${parteFour}`,
                dam_num: `235-${combo.dam_anio}-10-${parteone}`,
                withdrawal_date: format(new Date(), "yyyy-MM-dd"),
                billable_ruc_option: "customs_agency",
                additional_services: [],
                document_number: data.dni,
              };
            });

            const states$ = bodies.map((body) => {
              return createPrefactura.execute(body).state$.pipe(
                filter(
                  (state) =>
                    state.status === "FAILED" || state.status === "SUCCESS"
                ),
                tap((state) => {
                  setStatistics((stats) => ({
                    ...stats,
                    completed: stats.completed + 1,
                    success:
                      state.status === "SUCCESS"
                        ? stats.success + 1
                        : stats.success,
                    failed:
                      state.status === "FAILED"
                        ? stats.failed + 1
                        : stats.failed,
                  }));
                })
              );
            });
            zip(states$).subscribe((executions) => {
              alert("COMPLETE");
              const data = executions.map((e) => ({
                status: e.status,
                error: e.error,
                params: e.params,
              }));
              setStatus({ status: "COMPLETE", data });
              // eslint-disable-next-line no-console
              console.log(JSON.stringify(data));
            });
          }}
        >
          Generar Prefacturas
        </button>
      </div>
      <div className="p-grid">
        <pre>{JSON.stringify(statistics, null, 2)}</pre>
      </div>
      <div className="p-grid">
        <pre>{JSON.stringify(status.data, null, 2)}</pre>
      </div>
    </div>
  );
};
